import { CampanhaStatus } from '../enum/campanha-status.enum';

/**
 * Espelha CampanhaVigenciaGuard.GarantirNaoVigenteEAtiva: a API só aceita PATCH/PUT/DELETE
 * de campanha em Rascunho ou Agendada. Usado por toda tela que oferece editar/excluir campanha.
 */
export function podeEditarCampanha(status: CampanhaStatus): boolean {
  return status === CampanhaStatus.Rascunho || status === CampanhaStatus.Agendada;
}

export function podeExcluirCampanha(status: CampanhaStatus): boolean {
  return podeEditarCampanha(status);
}
